import { NativeAudio } from "@ionic-native/native-audio";
import { ServiceProvider } from "./../../providers/service/service";
import { TranslateService } from "@ngx-translate/core";
import { Storage } from "@ionic/storage";
import { MerchantShopPayRentalConfirmPage } from "./../merchant-shop-pay-rental-confirm/merchant-shop-pay-rental-confirm";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { QRScanner, QRScannerStatus } from "@ionic-native/qr-scanner";

@IonicPage()
@Component({
  selector: "page-merchant-shop-pay-rental",
  templateUrl: "merchant-shop-pay-rental.html",
})
export class MerchantShopPayRentalPage {
  scanSub: any;
  data = { shop_name: "", shop_id: "" };
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private qrScanner: QRScanner,
    private loadingCtrl: LoadingController,
    private storage: Storage,
    private translateService: TranslateService,
    private services: ServiceProvider,
    private nativeAudio: NativeAudio
  ) {
    this.data = this.navParams.data;
    this.nativeAudio.preloadSimple("uniqueId1", "assets/sounds/qr.aac");
  }

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");
    // var result = '{"plaza_id":1,"plaza_name":"Plaza A","space_no":2,"shop_id":5,"shop_name":"Book","discount":10,"action":"collect"}';
    // this.navCtrl.push(MerchantShopPayRentalConfirmPage, {result});

    this.qrScanner
      .prepare()
      .then((status: QRScannerStatus) => {
        if (status.authorized) {
          // console.log('Camera Permission Given');
          this.scanSub = this.qrScanner.scan().subscribe((result: string) => {
            //  console.log('Scanned something', text);

            let loader = this.loadingCtrl.create({
              // content: "Loading Please Wait...",
              duration: 1000,
            });
            loader.present();

            this.storage.get("info").then((info) => {
              var text = JSON.parse(result);
              // console.log("text=",text);

              if (text.action == "collect") {
                if (
                  text.plaza_id == info.team.plaza_id &&
                  text.shop_id == this.data.shop_id
                ) {
                  this.nativeAudio.play("uniqueId1");
                  this.navCtrl.push(MerchantShopPayRentalConfirmPage, {
                    result,
                  });
                } else {
                  this.translateService
                    .get("Invalid plaza or shop.")
                    .subscribe((value) => {
                      this.services.presentToast(value);
                    });
                }
              } else {
                this.translateService
                  .get("Invalid value.")
                  .subscribe((value) => {
                    this.services.presentToast(value);
                  });
              }
            });

            this.qrScanner.hide();
            this.scanSub.unsubscribe();
          });

          this.qrScanner.show();
        } else if (status.denied) {
          console.log("Camera permission denied");
        } else {
          console.log("Permission denied for this runtime.");
        }
      })
      .catch((e: any) => console.log("Error is", e));
  }

  backPage() {
    this.navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-shop-pay-rental/merchant-shop-pay-rental.ts